<div class="layout" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Left Sidebar -->
  <aside class="sidebar">
    <!-- Sidebar Header -->
    <div class="sidebar-header">
      @if (!sidebarCollapsed) {
        <p class="sidebar-tagline">Pro Check Printing</p>
      }
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav" aria-label="Main navigation">
      @for (section of navSections; track section.label ?? 'default') {
        @if (section.label && !sidebarCollapsed) {
          <div class="nav-section-label">
            {{ section.label }}
          </div>
        }
        <ul class="nav-list">
          @for (item of section.items; track item.route) {
            <li class="nav-item">
              <a
                [routerLink]="item.route"
                class="nav-link"
                [class.active]="isActiveRoute(item.route)"
                [title]="sidebarCollapsed ? item.label : ''">
                <span class="nav-icon">
                  @switch (item.icon) {
                    @case ('home') {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path
                          d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    }
                    @case ('requests') {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path
                          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    }
                    @case ('users') {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path
                          d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    }
                    @case ('company') {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M3 21h18"></path>
                        <path d="M5 21V7l8-4v18"></path>
                        <path d="M19 21V11l-6-4"></path>
                        <path d="M9 9v.01"></path>
                        <path d="M9 12v.01"></path>
                        <path d="M9 15v.01"></path>
                        <path d="M9 18v.01"></path>
                      </svg>
                    }
                    @case ('diagnostics') {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <polyline
                          points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                      </svg>
                    }
                    @default {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path
                          d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                      </svg>
                    }
                  }
                </span>
                @if (!sidebarCollapsed) {
                  <span class="nav-label">{{ item.label }}</span>
                }
                @if (item.badge && !sidebarCollapsed) {
                  <span class="nav-badge">{{ item.badge }}</span>
                }
              </a>
            </li>
          }
        </ul>
      }
    </nav>

    <!-- Collapse Toggle Button -->
    <div class="sidebar-footer">
      <button
        class="collapse-btn"
        (click)="toggleSidebar()"
        [attr.aria-label]="
          sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'
        ">
        @if (!sidebarCollapsed) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="11 17 6 12 11 7"></polyline>
            <polyline points="18 17 13 12 18 7"></polyline>
          </svg>
        }
        @if (sidebarCollapsed) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="13 17 18 12 13 7"></polyline>
            <polyline points="6 17 11 12 6 7"></polyline>
          </svg>
        }
      </button>
    </div>
  </aside>

  <!-- Main Content Area -->
  <div class="main-wrapper">
    <!-- Header -->
    <header class="header">
      <div class="header-left">
        <button
          class="menu-toggle"
          (click)="toggleSidebar()"
          aria-label="Toggle menu">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <button class="logo-button" (click)="onLogoClick()" title="Go to home">
          <ukg-logo alt="UKG" class="header-logo" rebrand="true"></ukg-logo>
        </button>
        <nav class="breadcrumb" aria-label="Breadcrumb">
          @for (item of breadcrumbItems; track item; let last = $last) {
            @if (item.route && !last) {
              <a [routerLink]="item.route" class="breadcrumb-item">{{
                item.label
              }}</a>
            }
            @if (!item.route || last) {
              <span class="breadcrumb-item" [class.current]="last">{{
                item.label
              }}</span>
            }
            @if (!last) {
              <span class="breadcrumb-separator">/</span>
            }
          }
        </nav>
      </div>
      <div class="header-right">
        @if (authService.currentUser$ | async; as user) {
          <div class="user-info">
            <span class="user-name"
              >{{ user.firstName }} {{ user.lastName }}</span
            >
            <span class="user-role">{{ user.arNumber }}</span>
          </div>
          <div class="user-avatar">
            {{ getUserInitials(user.firstName, user.lastName) }}
          </div>
        } @else {
          <div class="user-info">
            <span class="user-name">Guest User</span>
          </div>
          <div class="user-avatar">GU</div>
        }
        <button class="logout-btn" (click)="onLogout()" title="Logout">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      </div>
    </header>

    <!-- Page Content -->
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<!-- Mobile Overlay -->
@if (!sidebarCollapsed) {
  <button
    class="sidebar-overlay"
    (click)="toggleSidebar()"
    (keydown.escape)="toggleSidebar()"
    aria-label="Close sidebar"></button>
}
